import React, { Dispatch, FC, SetStateAction } from 'react';
import Alert from '@material-ui/lab/Alert';
import {
    Box,
    createStyles,
    // Link,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core';
import { AvailableTabs } from '../../shared/models/AvailableTabs';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        headerPadding: {
            paddingTop: theme.spacing(4),
        },
    }),
);
interface RulesProps {
    onClick: Dispatch<SetStateAction<AvailableTabs>>;
}

export const Rules: FC<RulesProps> = ({ onClick }) => {
    const classes = useStyles();
    return (
        <>
            <Typography
                variant="h4"
                paragraph
                classes={{ h4: classes.headerPadding }}
            >
                Zasady korzystania z wyszukiwarki
            </Typography>
            <Typography variant="body1" paragraph>
                Wyszukiwanie zanieczyszczeń jest możliwe po wpisaniu ciągu
                znaków (liter lub cyfr) w pola:
            </Typography>
            <Typography variant="body1" paragraph component="ul">
                <li>
                    Szukaj po <strong>Nazwie</strong> albo
                </li>
                <li>
                    Szukaj po <strong>Numerze CAS</strong>
                </li>
            </Typography>
            <Typography variant="body1" paragraph>
                Informacja zwrotna obejmuje następujące dane:
            </Typography>
            <Typography variant="body1" paragraph component="ul">
                <li>
                    <strong>Nr CAS</strong> - oznaczenie numeryczne substancji
                    według Chemical Abstracts Service
                </li>
                <li>
                    <strong>Nazwa</strong> - nazwa substancji
                </li>
                <li>
                    <strong>Inne nazwy</strong> - pozostałe nazwy, pod którymi
                    występuje substancja
                </li>
                <li>
                    <strong>Wzór sumaryczny</strong> - wzór przedstawiający
                    liczbę atomów każdego pierwiastka w cząsteczce związku
                    chemicznego
                </li>
                <li>
                    <strong>Nr pozycji w Krajowej bazie</strong> - liczba
                    porządkowa (lp.) substancji w{' '}
                    <em>
                        Wykazie gazów cieplarnianych i innych substancji
                        wprowadzanych do powietrza objętych systemem zarządzania
                        emisjami gazów cieplarnianych i innych substancji
                    </em>
                    , stanowiącym załącznik nr 1 do ustawy{' '}
                    <em>
                        o systemie zarządzania emisjami gazów cieplarnianych i
                        innych substancji
                    </em>
                </li>
                <li>
                    <strong>Nazwa w Krajowej bazie</strong> - nazwa substancji w{' '}
                    <em>
                        Wykazie gazów cieplarnianych i innych substancji
                        wprowadzanych do powietrza objętych systemem zarządzania
                        emisjami gazów cieplarnianych i innych substancji
                    </em>
                    , stanowiącym załącznik nr 1 do ustawy{' '}
                    <em>
                        o systemie zarządzania emisjami gazów cieplarnianych i
                        innych substancji
                    </em>
                </li>
                <li>
                    <strong>Nr pozycji na liście opłat</strong> - liczba
                    porządkowa (lp.) gazów lub pyłów wprowadzanych do powietrza
                    określonych w Tabeli A załącznika nr 1 do rozporządzenia
                    Rady Ministrów 22 grudnia 2017 r. w{' '}
                    <em>
                        sprawie jednostkowych stawek opłat za korzystanie ze
                        środowiska
                    </em>
                </li>
                <li>
                    <strong>Nazwa w systemie opłat</strong> - nazwa gazu lub
                    pyłów wprowadzanych do powietrza określonych w Tabeli A
                    załącznika nr 1 do rozporządzenia Rady Ministrów z dnia 22
                    grudnia 2017 r. w{' '}
                    <em>
                        sprawie jednostkowych stawek opłat za korzystanie ze
                        środowiska
                    </em>
                </li>
                <li>
                    <strong>Jednostkowa stawka</strong> - jednostkowa
                    stawka opłaty dla wybranego rodzaju gazu lub pyłu
                    na dany rok kalendarzowy
                </li>
            </Typography>
            <Alert severity="info">
                <Box mb={1}>
                    Jeżeli informacje o wyszukanej substancji wymagają korekty
                    zaleca się przekazanie informacji o koniecznej korekcie na
                    adres e-mail:{' '}
                    <a href="mailto:pomoc.kb@kobize.pl">pomoc.kb@kobize.pl</a>.
                </Box>
            </Alert>
        </>
    );
};
